import { render, staticRenderFns } from "./smsPushDialog.vue?vue&type=template&id=a5c8964c&scoped=true"
import script from "./smsPushDialog.vue?vue&type=script&lang=js"
export * from "./smsPushDialog.vue?vue&type=script&lang=js"
import style0 from "./smsPushDialog.vue?vue&type=style&index=0&id=a5c8964c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c8964c",
  null
  
)

export default component.exports